import styled from 'styled-components';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import CardBox from 'lib/components/CardBox';
import { TextField, Button as BaseButton } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { brand } from 'themes/brand';

export const ErrorMsg = styled.p`
  color: #fb5454 !important;
  font-size: 10pt;
  margin: 5px 0 0 5px;
`;

export const BaseTextField = styled(TextField)`
  width: 100%;
`;

export const BaseTextFieldCPF = styled(TextField)`
  width: 48.6%;
`;

export const FileInput = styled.input`
  width: calc(100% - 30px);
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 15px;
`;

export const Header = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  height: 45px;
  margin-bottom: 25px;

  input[type='file'] {
    display: none;
  }

  label {
    color: #fff;
    background-color: ${brand.primary};
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
      0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    padding: 6px 16px;
    border-radius: 4px;
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1.75;
    letter-spacing: 0.02857em;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      margin-right: 8px;
    }
  }

  label:hover {
    cursor: pointer;
    background-color: ${brand.primary};
    box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%),
      0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);
  }
`;
export const FieldRow = styled.div`
  width: 100%;
  display: flex;
  padding: 10px 0px;
  gap: 20px;
`;

export const FixedLabel = styled.div`
  color: ${brand.primary};
  font-weight: 400;
  font-size: 10pt;
  line-height: 1.4375em;
  letter-spacing: 0.00938em;
  padding: 3px 5px;
  text-overflow: ellipsis;
  max-width: calc(133% - 24px);
  position: absolute;
  z-index: 1;
  margin-top: -12px;
  margin-left: 10px;
  background-color: #fff;
`;

export const Button = styled(BaseButton)`
  .MuiButton-startIcon,
  .MuiCircularProgress-root {
    width: 15px !important;
    height: 15px !important;
  }
`;

export const BaseBreadcrumbs = styled(Breadcrumbs)`
  a {
    color: #555;
    text-decoration: none;
  }

  a:hover {
    color: #333;
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const BaseCardBox = styled(CardBox)`
  margin: 25px 0 50px;

  h3 {
    color: ${brand.text};
    font-weight: 700;
    margin: 0;
    font-size: 16pt;
  }
`;

export const FakeButton = styled.div<{ variant: string | undefined }>`
  background-color: ${({ variant }) => variant};
  color: ${brand.text};
  font-weight: 500;
  text-align: center;
  padding: 5px 0px;
  width: 110px;
  text-transform: lowercase;
  border-radius: 4px;
`;

export const WhatsappButtonWrap = styled.button<{ isNone: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 10px 0 8px;
  border-radius: 9999px;
  background: #fff;
  font-size: 0.75rem;
  font-weight: 500;
  color: #111827;
  white-space: nowrap;
  transition: border-color 0.15s, background 0.15s;
  outline: none;
  cursor: pointer;

  border: ${({ isNone }) =>
    isNone ? `1px dashed ${brand.border}` : `1px solid ${brand.border}`};

  &:hover {
    border-color: #6b7280;
    background: #f9fafb;
  }

  svg.send-icon {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
    color: #6b7280;
  }

  &:disabled {
    cursor: not-allowed;
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
    color: #9ca3af;

    svg.send-icon {
      color: ${brand.border};
    }
  }
`;

export const WhatsappBadgeCircle = styled.span<{ color: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  flex-shrink: 0;
  background-color: ${({ color }) => color}2e;

  svg {
    width: 10px;
    height: 10px;
    color: ${({ color }) => color};
  }

  button:disabled & {
    background-color: #e5e7eb;

    svg {
      color: ${brand.border};
    }
  }
`;

export const FileUploadCard = styled.div`
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
`;

export const FileUploadCardText = styled.div`
  flex: 1;
  p {
    margin: 0;
  }
  p:first-child {
    font-weight: 500;
    font-size: 0.875rem;
    margin-bottom: 4px;
  }
  p:last-child {
    font-size: 0.75rem;
    color: #888;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 8px;
`;

export const SectionLabel = styled.p`
  font-weight: 600;
  font-size: 0.75rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${brand.textSecondary};
  margin: 0;
`;

export const ManualLink = styled.button`
  background: none;
  border: none;
  color: ${brand.primary};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.875rem;
  padding: 0;
  &:hover {
    text-decoration: underline;
  }
`;

export const SelectFileButton = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: 1px solid ${brand.primary};
  border-radius: 4px;
  color: ${brand.primary};
  cursor: pointer;
  font-size: 0.875rem;
  white-space: nowrap;
  flex-shrink: 0;
  input {
    display: none;
  }
  &:hover {
    background-color: rgba(25, 118, 210, 0.04);
  }
`;

export const HintText = styled.span`
  margin-left: 16px;
  font-size: 0.8rem;
  color: #888;
  align-self: center;
`;

export const UploadedFileRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: #f5f5f5;
  border-radius: 6px;
  font-size: 0.875rem;
  color: #333;

  span {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const RemoveFileButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #888;
  display: flex;
  align-items: center;
  padding: 2px;
  flex-shrink: 0;
  border-radius: 50%;
  &:hover {
    color: #d32f2f;
    background: rgba(211, 47, 47, 0.08);
  }
`;
